import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Button } from '@comparethemarketau/manor-button';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

import { withNavigateToMoreInfoPage } from './with_navigate_to_more_info_page';
import { withQuoteFlatten } from './with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    button: {
        margin: 0,
        padding: 0,
        width: '100%',
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.base,
        lineHeight: theme.lineHeight.tight,
        '&:hover': {
            background: 'unset'
        }
    }
}));

const _ViewProductDetails = ({ className, navigateToMoreInfoPage, productId }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const handleClick = () => {
        navigateToMoreInfoPage(productId);
    };

    return (
        <div className={className}>
            <Button
                variant="tertiary"
                icon={faAngleRight}
                iconAlign="right"
                trackingLabel="View all details"
                className={classes.button}
                handleClick={handleClick}
            >
                View product details
            </Button>
        </div>
    );
};

_ViewProductDetails.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productId: PropTypes.string.isRequired,
    navigateToMoreInfoPage: PropTypes.func
};

const ViewProductDetails = withQuoteFlatten(withNavigateToMoreInfoPage(_ViewProductDetails));

export { ViewProductDetails };
